/* eslint-disable new-cap */
/* eslint-disable max-len */
import * as React from "react"
import Layout from "../../components/Layout/Layout.js"
import { graphql } from "gatsby"
import Parser from "html-react-parser"
import RelatedLinks from "../../components/RelatedLinks/RelatedLinks.js"
import RelatedDocuments from "../../components/RelatedDocuments/RelatedDocuments.js"
import RelatedPages from "../../components/RelatedPages/RelatedPages.js"
import { Icon } from "../../components/Icon/Icon"
import { Helmet } from "react-helmet"
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.jsx"
import RelatedFields from "../../components/RelatedFields/RelatedFields.js"

const NewsPage = data => {
  const root = data.data.wpNews.acf_news
  const title = root.title
  const summary = root.summary
  const date = data.data.wpNews.date
  const longDescription = root.articleText
  const category = root.category

  const imageURL = root.featuredImage.mediaItemUrl
  const imageAlt = root.featuredImage.altText

  // Related Fields
  const relatedServices = root.services
  const relatedNews = root.relatedNews
  const relatedProviders = root.relatedProviders
  const relatedDocuments = root.relatedDocuments
  const relatedLinks = root.relatedLinks
  const relatedPages = root.relatedPages
  const relatedProjects = root.relatedProjects

  let categorySlug

  switch (category) {
    case "Closures":
      categorySlug = "closures"
      break
    case "F&S Organization":
      categorySlug = "f-and-s-organization"
      break
    case "Events and Training":
      categorySlug = "events-and-training"
      break
    case "Project Updates":
      categorySlug = "project-updates"
      break
    case "Strategic Initiatives":
      categorySlug = "strategic-initiatives"
      break
    default:
      categorySlug = "f-and-s-organization"
      break
  }

  const parentLink = "/News/Category/" + categorySlug

  return (
    <Layout>
      <Helmet title={title} defer={false}>
        <meta property="og:image" content={imageURL}></meta>
      </Helmet>

      <div className="whitebg">
        <div className="container">
          <div className="serviceTop">
            <Breadcrumb
              pageTitle={title}
              parent={category}
              parentLink={parentLink}
            />

            <Icon className="imgMargin" category={category}></Icon>
            <span className="primaryLinkLarge">{category}</span>
            <br />
            <h1 className="primaryTitle">{title}</h1>
            <p className="paragraph greyDarkestTxt">{date}&nbsp;</p>
            <p className="paragraph greyDarkestTxt">{summary}</p>
            <img alt={imageAlt} className="newsImage" src={imageURL}></img>
          </div>
          <div className="rightTop">
            {relatedPages?.length ? (
              <div className="container">
                <RelatedPages pages={relatedPages}></RelatedPages>
              </div>
            ) : null}
            {relatedLinks && relatedLinks.length ? (
              <div style={{ width: "300px", marginTop: ".5rem" }}>
                <h2 className="tertiaryTitle">Links</h2>
                <RelatedLinks links={relatedLinks}></RelatedLinks>
              </div>
            ) : null}
            {relatedDocuments?.length ? (
              <div style={{ width: "300px", marginTop: ".5rem" }}>
                <p className="tertiaryTitle">Documents</p>
                <RelatedDocuments
                  documents={relatedDocuments}
                ></RelatedDocuments>
              </div>
            ) : null}
          </div>
        </div>

        <div className="container newsBottom">
          <div style={{ width: "100%" }}>{Parser(longDescription)}</div>
        </div>
        <RelatedFields
          relatedProviders={relatedProviders}
          relatedServices={relatedServices}
          relatedNews={relatedNews}
          relatedProjects={relatedProjects}
        />
      </div>
    </Layout>
  )
}

export default NewsPage

export const query = graphql`
  query NewsQuery($id: String) {
    wpNews(id: { eq: $id }) {
      acf_news {
        articleText
        otherNews {
          ... on WpNews {
            id
            date(formatString: "MMM DD, YYYY | h:mm a")
            title
            slug
            acf_news {
              title
              category
              sunsetDate
              articleText
              featuredImage {
                altText
                mediaItemUrl
              }
            }
          }
        }
        project {
          ... on WpProject {
            id
          }
        }
        providers {
          ... on WpProvider {
            id
            slug
            acf_providers {
              providerName
              description
              image {
                altText
                mediaItemUrl
              }
              contact {
                ... on WpContact {
                  id
                  acf_contacts {
                    name
                    phoneNumber
                    email
                    phoneNumber2
                    email2
                    hours
                    physicalAddress
                    physicalAddress2
                    customComment
                  }
                }
              }
            }
          }
        }
        services {
          ... on WpService {
            id
            acf_services {
              serviceTitle
              category
            }
            slug
          }
        }
        title
        sunsetDate
        featuredImage {
          altText
          mediaItemUrl
        }
        category
        summary
        relatedLinks {
          ... on WpLink {
            id
            title
            acf_link {
              link
            }
          }
        }
        relatedDocuments {
          ... on WpDocument {
            id
            slug
            title
            acf_documents {
              document {
                mediaItemUrl
              }
            }
          }
        }
        relatedProjects {
          ... on WpProject {
            id
            slug
            title
            acf_project {
              title
              description
            }
          }
        }
        relatedPages {
          ... on WpPage {
            id
            title
            slug
          }
        }
        relatedProviders {
          ... on WpProvider {
            id
            slug
            acf_providers {
              providerName
              description
              image {
                altText
                mediaItemUrl
              }
              contact {
                ... on WpContact {
                  id
                  acf_contacts {
                    name
                    phoneNumber
                    email
                    phoneNumber2
                    email2
                    hours
                    physicalAddress
                    physicalAddress2
                    customComment
                  }
                }
              }
            }
          }
        }
      }
      slug
      date(formatString: "MMM DD, YYYY | h:mm a")
    }
  }
`

export function Head() {
  return (
    <>
      <html lang="en" />
    </>
  )
}
